module.exports = __webpack_public_path__ + "img/F5-2B.704b7c2e.png";